export const basic = ({ theme }) => ({
    fontSize: '12px',
    color: theme.colors.blueGrey4,
    letterSpacing: '0.1px',
    lineHeight: 1.25,
});
